import {useDomain} from "domain/provider";
import {FormSelect} from "base/component/form";

import Grid from "@mui/material/Grid";
import {ConcelloHiddenAuth} from "concello/auth";

const EDARFormTratamentoRendementoFields = ({layout = "row"}) => {
    const {dominioedartipotratamento, dominiosino} = useDomain();

    return (
        <Grid container columnSpacing={2} direction={layout}>
            <ConcelloHiddenAuth>
                <Grid item xs={12} md={6}>
                    <FormSelect
                        name="tipo_tratamento"
                        label="Tratamento"
                        options={dominioedartipotratamento}
                        tooltipText="Tipo de tratamento da instalación"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormSelect
                        name="tratamento_avanzado"
                        label="Tratamento avanzado"
                        options={dominiosino}
                        tooltipText="Rendemento de depuración da instalación segundo"
                    />
                </Grid>
            </ConcelloHiddenAuth>
        </Grid>
    );
};

export default EDARFormTratamentoRendementoFields;
